module.exports = __webpack_public_path__ + "img/mylittle.032266b1.png";